<template>
  <footer class="app-footer flex">
    <div class="full-screen-container flex align-start space-between height-all width-all wrap gap50">
      <AppCreditsSection/>
      <div class="flex align-start gap50 wrap contact-section">
        <div class="inner-item flex column gap20" v-if="org?.mediaLinks?.length">
          <span>{{$t('contact')}} {{org.name}}</span>
          <OrgMediaLinks :organization="org" :color="selectedTheme?.colors?.[2]" :imgs="mediaSvgs"/>
        </div>
        <div class="inner-item respect-lines">
          {{org?.designPreferences?.contactMsg || ''}}
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import OrgMediaLinks from '@/apps/common/modules/organization/cmps/OrgMediaLinks.vue'
import { getSvgs } from '@/apps/clientApps/stream-tv/assets/images/svgs';
import AppCreditsSection from '../../../../common/modules/common/cmps/AppCreditsSection.vue';
export default {
  name: "AppFooter",
  components: { OrgMediaLinks, AppCreditsSection },
  computed: {
    org () {
      return this.$store.getters['organization/selectedItem'] || {};
    },
    selectedTheme() {
      return this.$store.getters['selectedTheme'];
    },
    mediaSvgs() {
      return getSvgs(this.selectedTheme?.colors?.[2]).media;
    }
  }
}
</script>
 
<style lang="scss">
@import '@/assets/styles/global/index';
.megaphon-app {
  .app-footer {
    min-height: rem(60px);
    font-size: rem(14px);
    padding: rem(20px);
    // color: #9D9D9D;
    .powered-by {
        direction: ltr;
        img {
          height: em(25px);
          width: unset;
        }
    }
    @media (max-width: $small-screen-break) {
      .full-screen-container, .contact-section {
        flex-direction: column;
        align-items: center;
        // >*, .inner-item {
        //   width: 100%;
        // }
      }
    }
  }
}
</style>